<template>
    <BaseAlert :type="Functional.Warning">
        {{ $t('globalMessages.unconfirmedPassword.message') }}
    </BaseAlert>
</template>

<script setup lang="ts">
import { Functional } from '@/types';
</script>
